import React from 'react';
var Loading = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'medium' : _b, _c = _a.colour, colour = _c === void 0 ? 'purple' : _c, className = _a.className;
    var loadingClasses = "jg-loading--" + size + " jg-loading--" + colour;
    var classes = className
        ? [className, loadingClasses].join(' ')
        : loadingClasses;
    return (React.createElement("div", { "aria-label": "content is loading", className: classes },
        React.createElement("svg", { className: "jg-loading__container", viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("circle", { className: "jg-loading__circle", cx: "24", cy: "24", r: "20" }))));
};
export default Loading;
//# sourceMappingURL=Loading.js.map